import React from 'react';
import PropTypes from "prop-types";
import AmenityConsecutiveAvailabilityInput from "../../../../Components/Inputs/Availability/AmenityConsecutiveAvailabilityInput";
import SingleAvailabilitySlotSelector from "../../../../Components/Inputs/Availability/SingleAvailabilitySlotSelector";
import AvailabilityCheckWrapper from "./AvailabilityCheckWrapper";

// TODO: Fix prop drilling and use more parameters directly from BookingFormProvider
const AmenityFixedAvailability = (props) => {

    return (<>
        <AvailabilityCheckWrapper
            bookingConfig={props.bookingConfig}
            availability={props.availability}
            bookingDate={props.bookingDate}
            amenityId={props.amenity.id}
            unitId={props.unitId}

            onBookingDateChange={props.onBookingDateChange}
            showNextAvailabilityButton={props.showNextAvailabilityButton}
        >
            {(props.useConsecutiveSlots)
                ? (
                    <AmenityConsecutiveAvailabilityInput
                        bookingConfig={props.bookingConfig}
                        availability={props.availability}

                        bookingDate={props.bookingDate}
                        selectedInterval={props.selectedInterval}
                        onChange={props.onChange}
                    />
                ) : (
                    <SingleAvailabilitySlotSelector
                        availableIntervals={props.availability.availableIntervals}
                        timeslotsRemaining={props.availability.timeslotsRemaining}
                        bookingDate={props.bookingDate}

                        onClick={props.onChange}
                    />
                )
            }
        </AvailabilityCheckWrapper>
    </>);
};

AmenityFixedAvailability.propTypes = {
    bookingConfig: PropTypes.object.isRequired,
    availability: PropTypes.object.isRequired,
    bookingDate: PropTypes.string.isRequired,
    amenity: PropTypes.object.isRequired,
    unitId: PropTypes.string.isRequired,

    selectedInterval: PropTypes.object,

    onChange: PropTypes.func.isRequired,
    onBookingDateChange: PropTypes.func.isRequired,
    //onSingleSlotClick: PropTypes.func.isRequired,
};

AmenityFixedAvailability.defaultProps = {};

export default AmenityFixedAvailability;
